module.exports = __webpack_public_path__ + "static/media/10.24e2641e.gif";